import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  BoxImage: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "38px",
    width: "38px",
    borderRadius: "5px",
    opacity: "1",
    "&:hover": {
      backgroundColor: "rgba(20, 20, 43, 0.04)",
    },
  },
}));
